import useSales from 'shared/hooks/useSales';
import useBook from 'shared/hooks/useBook';
import useWebsiteEditor from 'shared/hooks/useWebsiteEditor';
import { ApiService } from 'shared/helpers/api';
import type { HeroBasicProps } from '../HeroBasic';
import type { MiniHeroProps } from '../MiniHero';

/**
 * @function useGeneralActions
 *
 * @description This hook is used for general sales page actions.
 * For example upload images, etc.
 */
const useGeneralActions = (props: HeroBasicProps | MiniHeroProps) => {
  const { meta } = props;
  const { editable } = useWebsiteEditor();
  const { bookId } = useBook();
  const { salesPageId, updateImageMeta, isWebsiteOnly, removeMetaTag } = useSales();

  const handleUploadAction = async (
    file: File,
    setResize: (data: { width: number; height: number }) => void,
    mockup_type: 'book_mockup' | 'hero_mockup' | 'minihero_mockup'
  ) => {
    if (!meta['accessorKey'] || !editable) return;
    const formData = new FormData();
    if (isWebsiteOnly) formData.append('name', mockup_type);
    else formData.append('type', meta['accessorKey']);
    removeMetaTag(meta['accessorKey'], 'image_placeholder');
    formData.append('file', file);
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const width = img.width;
        const height = img.height;
        setResize({ width, height });
        updateImageMeta(meta['accessorKey'], width, 'width');
        updateImageMeta(meta['accessorKey'], height, 'height');
      };
      img.src = e.target?.result as string;
    };

    reader.readAsDataURL(file);

    if (isWebsiteOnly) {
      formData.append('file', file);
      const response = await ApiService.post(
        `/book-generator/books/${bookId}/book_media/`,
        formData
      );
      updateImageMeta(meta['accessorKey'], response.data.file, 'image');
    } else {
      const response = await ApiService.post(`/sales/sales-page/${salesPageId}/media/`, formData);
      updateImageMeta(meta['accessorKey'], response.data.file, 'image');
    }
  };
  return {
    handleUploadAction
  };
};

export default useGeneralActions;
